// eslint-disable-next-line no-shadow
export var FACILITY_SUMMARY_VIEW_TYPES;
(function (FACILITY_SUMMARY_VIEW_TYPES) {
    FACILITY_SUMMARY_VIEW_TYPES["SPOT_LIST"] = "spot-list";
    FACILITY_SUMMARY_VIEW_TYPES["SPOT_DETAIL"] = "spot-detail";
    FACILITY_SUMMARY_VIEW_TYPES["SPOT_MAP"] = "spot-map";
    FACILITY_SUMMARY_VIEW_TYPES["CHECKOUT_LIST"] = "checkout";
})(FACILITY_SUMMARY_VIEW_TYPES || (FACILITY_SUMMARY_VIEW_TYPES = {}));
